let globalDefaultText = "Add to Cart"
let globalDefaultPrice = "0"
let globalDefaultComparePrice = "0"
let globalDefaultLabel = ""
let currentDefaultLabel = ""
let lastLabelType = "global"

const localeMap = {
  USD: "en-US",    // United States Dollar
  EUR: "de-DE",    // Euro (Germany format)
  GBP: "en-GB",    // British Pound Sterling
  CAD: "en-CA",    // Canadian Dollar
  AUD: "en-AU",    // Australian Dollar
  JPY: "ja-JP",    // Japanese Yen
  CNY: "zh-CN",    // Chinese Yuan
  INR: "en-IN",    // Indian Rupee
  KRW: "ko-KR",    // South Korean Won
  SGD: "en-SG",    // Singapore Dollar
  HKD: "zh-HK",    // Hong Kong Dollar
  NZD: "en-NZ",    // New Zealand Dollar
  MXN: "es-MX",    // Mexican Peso
  BRL: "pt-BR",    // Brazilian Real
  CHF: "de-CH",    // Swiss Franc
  SEK: "sv-SE",    // Swedish Krona
  NOK: "nb-NO",    // Norwegian Krone
  DKK: "da-DK",    // Danish Krone
  PLN: "pl-PL",    // Polish Złoty
  CZK: "cs-CZ",    // Czech Koruna
  HUF: "hu-HU",    // Hungarian Forint
  RUB: "ru-RU",    // Russian Ruble
  TRY: "tr-TR",    // Turkish Lira
  ZAR: "en-ZA",    // South African Rand
  THB: "th-TH",    // Thai Baht
  MYR: "ms-MY",    // Malaysian Ringgit
  PHP: "en-PH",    // Philippine Peso
  IDR: "id-ID",    // Indonesian Rupiah
  VND: "vi-VN",    // Vietnamese Đồng
  ILS: "he-IL",    // Israeli New Shekel
  AED: "ar-AE",    // UAE Dirham
  SAR: "ar-SA",    // Saudi Riyal
  QAR: "ar-QA",    // Qatari Riyal
  KWD: "ar-KW",    // Kuwaiti Dinar
  BHD: "ar-BH",    // Bahraini Dinar
  OMR: "ar-OM",    // Omani Rial
  JOD: "ar-JO",    // Jordanian Dinar
  LBP: "ar-LB",    // Lebanese Pound
  EGP: "ar-EG",    // Egyptian Pound
  CLP: "es-CL",    // Chilean Peso
  COP: "es-CO",    // Colombian Peso
  PEN: "es-PE",    // Peruvian Sol
  ARS: "es-AR",    // Argentine Peso
  UYU: "es-UY",    // Uruguayan Peso
  RON: "ro-RO",    // Romanian Leu
  BGN: "bg-BG",    // Bulgarian Lev
  HRK: "hr-HR",    // Croatian Kuna
  RSD: "sr-RS"     // Serbian Dinar
}

function formatPrice(cents) {
  const dollars = parseInt(cents) / 100
  const currency = window.Shopify.currency.active
  const locale = localeMap[currency] || 'en-US'
  
  const isWholeNumber = cents % 100 === 0

  return dollars.toLocaleString(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,//isWholeNumber ? 0 : undefined
    maximumFractionDigits: 0
  })
}

function setPrice(price, comparePrice, label) {
  globalDefaultPrice = price
  globalDefaultComparePrice = comparePrice
  if (label) {
    currentDefaultLabel = label
    lastLabelType = "custom"
  } else {
    currentDefaultLabel = globalDefaultLabel
    lastLabelType = "global"
  }

  document.querySelectorAll("buy-button").forEach(btn => {
    btn.updateFromAttributes?.()
  })

  document.querySelectorAll(".ante-price:not(.static):not(.ante-buy-button-price)").forEach(priceEl => {
    const comparePriceEl = priceEl.querySelector(".ante-buy-compare-price")
    const priceSpanEl = priceEl.querySelector(".ante-buy-price")
    const labelEl = priceEl.querySelector(".ante-buy-label")
    
    if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
      comparePriceEl.textContent = formatPrice(comparePrice)
      comparePriceEl.hidden = false
    } else {
      comparePriceEl.hidden = true
    }
    
    priceSpanEl.textContent = formatPrice(price)
    
    if (labelEl) {
      if (currentDefaultLabel) {
        labelEl.textContent = currentDefaultLabel
        labelEl.hidden = false
      } else {
        labelEl.hidden = true
      }
    }
  })

  const savings = comparePrice - price
  document.querySelectorAll(".ante-buy-savings").forEach(e => {
    if (savings > 0) {
      e.textContent = `${formatPrice(savings)}`
      e.hidden = false
    } else {
      e.hidden = true
    }
  })

  const percentage = Math.round((1 - price / comparePrice) * 100)
  document.querySelectorAll(".ante-buy-percentage").forEach(e => {
    if (percentage > 0) {
      const span = e.querySelector("span")
      if (span) {
        span.textContent = `${percentage}%`
      } else {
        e.textContent = `${percentage}% OFF`
      }
      e.hidden = false
    } else {
      e.hidden = true
    }
  })
}

function setDefaultText(text) {
  globalDefaultText = text
  document.querySelectorAll("buy-button").forEach(btn => {
    btn.updateFromAttributes?.()
  })
}

function setDefaultLabel(text) {
  globalDefaultLabel = text
  if (lastLabelType === "global") {
    currentDefaultLabel = globalDefaultLabel
  }
  document.querySelectorAll("buy-button").forEach(btn => {
    btn.updateFromAttributes?.()
  })
  document.querySelectorAll(".ante-price.static:not(.ante-buy-button-price)").forEach(priceEl => {
    const labelEl = priceEl.querySelector(".ante-buy-label:not(.custom)")
    if (labelEl) {
      if (text) {
        labelEl.textContent = text
        labelEl.hidden = false
      } else {
        labelEl.hidden = true
      }
    }
  })
}

// Dynamic Marquee

function initMarquees() {
  const marquees = document.querySelectorAll(".marquee:not(.initialised)")
  for (const marquee of marquees) {
    const div = document.createElement("div")
    div.className = "marquee-sub"
    div.append(...marquee.children)
    marquee.append(div)

    const measure = div.cloneNode(true)
    measure.classList.add("marquee-measure")
    marquee.append(measure)

    const pxPerSec = marquee.dataset.speed ? parseFloat(marquee.dataset.speed) : 128
    let lastWidth = marquee.clientWidth

    function adjust() {
      const base = marquee.querySelector(".marquee-sub")
      const measureWidth = measure.clientWidth
      const needClones = Math.ceil(marquee.clientWidth / measureWidth)

      const clones = marquee.querySelectorAll(".marquee-sub.clone")
      const current = clones.length

      if (current > needClones) {
        for (let i = needClones; i < current; i++) clones[i].remove()
      } else if (current < needClones) {
        for (let i = current; i < needClones; i++) {
          const clone = base.cloneNode(true)
          clone.classList.add("clone")
          marquee.insertBefore(clone, measure)
        }
      }

      const duration = measureWidth / pxPerSec
      marquee.querySelectorAll(".marquee-sub").forEach(sub => {
        sub.style.animation = "none"
        void sub.offsetWidth
        sub.style.animation = `marquee ${duration}s linear infinite`
      })

      if (!("infinite" in marquee.dataset)) {
        marquee.classList.toggle("scrolling", measureWidth > marquee.clientWidth)
      }

      lastWidth = marquee.clientWidth
    }

    setTimeout(adjust, 0)
    window.addEventListener("resize", () => {
      if (marquee.clientWidth !== lastWidth) adjust()
    })

    marquee.classList.add("initialised")

    if ("infinite" in marquee.dataset) marquee.classList.add("scrolling")

    if ("pausable" in marquee.dataset) {
      let paused = false
      const pause = () => marquee.classList.add("paused")
      const resume = () => marquee.classList.remove("paused")

      marquee.addEventListener("mouseenter", pause)
      marquee.addEventListener("mouseleave", () => {
        paused = false
        resume()
      })

      marquee.addEventListener("touchstart", () => {
        paused = !paused
        if (paused) pause()
        else resume()
      })
    }

    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll("img[loading='lazy']").forEach(img => {
            img.loading = "eager"
          })
          observer.unobserve(entry.target)
        }
      }
    })
    observer.observe(marquee)
  }
}

// Sticky Scroll Slider

class StickyScrollSlider extends HTMLElement {
  constructor() {
    super()
    this._activeSteps = new Set()
    this._isActive = false
  }

  connectedCallback() {
    if (this._initialized) return

    requestAnimationFrame(() => {
      this._initialized = true

      const stickyContainer = document.createElement("div")
      stickyContainer.className = "sticky-scroll-slider-sticky"

      const scrollContainer = document.createElement("div")
      scrollContainer.className = "sticky-scroll-slider-scroll"

      const paddedContainer = document.createElement("div")
      paddedContainer.className = "sticky-scroll-slider-wrapper"
      paddedContainer.append(...Array.from(this.children))

      scrollContainer.appendChild(paddedContainer)
      stickyContainer.appendChild(scrollContainer)
      this.appendChild(stickyContainer)

      this.style.setProperty("--scroll-progress", 0)

      const steps = this.hasAttribute("steps") ? parseInt(this.getAttribute("steps")) : 0
      const buffer = this.hasAttribute("buffer") ? parseFloat(this.getAttribute("buffer")) / 100 : 0

      let ticking = false

      const update = () => {
        ticking = false

        const stickyTop = parseFloat(getComputedStyle(stickyContainer).top)
        const rect = this.getBoundingClientRect()
        const scrollStart = window.scrollY + rect.top - stickyTop
        const scrollEnd = window.scrollY + rect.bottom - stickyContainer.offsetHeight - stickyTop
        const progress = Math.min(Math.max((window.scrollY - scrollStart) / (scrollEnd - scrollStart), 0), 1)

        const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth
        scrollContainer.scrollLeft = progress * maxScroll

        this.style.setProperty("--scroll-progress", progress)

        const isCurrentlyActive = progress > 0 && progress < 1
        
        if (isCurrentlyActive && !this._isActive) {
          const direction = progress < 0.5 ? 'forward' : 'backward'
          this.dispatchEvent(new CustomEvent('enter', {
            detail: { direction }
          }))
          this._isActive = true
        } else if (!isCurrentlyActive && this._isActive) {
          const direction = progress >= 1 ? 'forward' : 'backward'
          this.dispatchEvent(new CustomEvent('leave', {
            detail: { direction }
          }))
          this._isActive = false
        }

        if (steps > 0) {
          const stepSize = 1 / steps
          const bufferSize = buffer * stepSize

          const unboundedMin = -bufferSize
          const unboundedMax = 1 + bufferSize
          const unboundedRange = unboundedMax - unboundedMin

          for (let i = 1; i <= steps; i++) {
            const stepStart = (i - 1) * stepSize
            const stepEnd = i * stepSize

            const unboundedStart = stepStart - bufferSize
            const unboundedEnd = stepEnd + bufferSize

            const activeStart = (unboundedStart - unboundedMin) / unboundedRange
            const activeEnd = (unboundedEnd - unboundedMin) / unboundedRange

            let stepProgress = 0

            if (progress >= activeStart && progress <= activeEnd) {
              stepProgress = (progress - activeStart) / (activeEnd - activeStart)
              stepProgress = Math.min(Math.max(stepProgress, 0), 1)
            } else if (progress > activeEnd) {
              stepProgress = 1
            }

            this.style.setProperty(`--step-${i}-progress`, stepProgress)

            const isStepActive = progress >= activeStart && progress <= activeEnd
            const isStepTrulyActive = isStepActive && stepProgress > 0 && stepProgress < 1
            const wasStepActive = this._activeSteps.has(i)

            if (isStepTrulyActive && !wasStepActive) {
              const direction = stepProgress < 0.5 ? 'forward' : 'backward'
              this.dispatchEvent(new CustomEvent('stepenter', {
                detail: { step: i, direction }
              }))
              this._activeSteps.add(i)
            } else if (!isStepTrulyActive && wasStepActive) {
              const direction = stepProgress >= 0.5 ? 'forward' : 'backward'
              this.dispatchEvent(new CustomEvent('stepleave', {
                detail: { step: i, direction }
              }))
              this._activeSteps.delete(i)
            }

            this.classList.toggle(`step-${i}`, isStepActive)
          }
        }
      }

      this._onScroll = () => {
        if (!ticking) {
          requestAnimationFrame(update)
          ticking = true
        }
      }

      this._onScroll()

      window.addEventListener("scroll", this._onScroll, { passive: true })
      window.addEventListener("resize", this._onScroll)

      this._resizeObserver = new ResizeObserver(this._onScroll)
      this._resizeObserver.observe(this)
      this._resizeObserver.observe(scrollContainer)
    })
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this._onScroll)
    window.removeEventListener("resize", this._onScroll)
    this._resizeObserver.disconnect()
  }
}

customElements.define("sticky-scroll-slider", StickyScrollSlider)

addEventListener("DOMContentLoaded", () => {
  document.body.classList.add("ante-loaded")

  // Page Width

  function updatePageWidth() {
    document.documentElement.style.setProperty("--ante-page-width", `${document.documentElement.clientWidth}px`)
    document.documentElement.style.setProperty("--ante-container-width-full", `min(var(--content-width), ${document.documentElement.clientWidth}px - var(--section-horizontal-padding) * 2)`)
  }
  
  updatePageWidth()
  window.addEventListener("resize", updatePageWidth)

  // Smooth scrolling
  
  const nav = document.getElementById("ante-lander-nav")

  window.getStickyTop = () => {
    const styles = getComputedStyle(document.body)
    const anteHeaderHeight = parseFloat(styles.getPropertyValue("--ante-header-height"))
    const sectionHorizontalPadding = parseFloat(styles.getPropertyValue("--section-horizontal-padding"))
    if (nav?.classList.contains("nav-type-floating")) {
      return anteHeaderHeight + Math.min(40, sectionHorizontalPadding) * 2
    } else {
      return anteHeaderHeight + Math.min(40, sectionHorizontalPadding)
    }
  }

  window.smoothScroll = element => {
    let attempts = 0
    let lastTop = null

    function scroll() {
      const top = element.getBoundingClientRect().top + window.scrollY - getStickyTop()
      if (lastTop !== null && Math.abs(top - lastTop) < 2) return
      lastTop = top

      window.scrollTo({ top, behavior: "smooth" })
      attempts++
      if (attempts < 4) setTimeout(scroll, 500)
    }

    scroll()
  }

  // Anchor id smooth scrolling and anchor modals

  document.body.addEventListener("click", e => {
    const link = e.target.closest("a[href^='#']")
    if (!link) return

    const id = link.getAttribute("href").slice(1)
    if (!id) return

    const modalContent = document.getElementById(`modal-content-${id}`)
    if (modalContent) {
      e.preventDefault()
      try {
        const data = JSON.parse(modalContent.textContent)
        showModal(data.title, data.content)
      } catch {}
      return
    }

    const target = document.getElementById(id)
    if (!target) return

    e.preventDefault()
    smoothScroll(target)
  })

  // Modals

  const modals = document.createElement("div")
  modals.id = "modals"
  document.body.append(modals)

  function makeModal(title, content, id) {
    const container = document.createElement("div")
    if (id) {
      container.id = id
    }
    container.classList.add("modal-container")
    container.setAttribute("tabindex", "-1")
    container.innerHTML = `
      <div class="modal-element">
        <div class="modal-title-row">
          <div class="modal-title">${title ?? "Modal"}</div>
          <button class="modal-close">
            <svg width="28" height="28" viewBox="0 0 24 24"><path d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" /></svg>
          </button>
        </div>
        <div class="modal-contents"></div>
      </div>
    `
    const contents = container.querySelector(".modal-contents")
    if (typeof content === "string") {
      contents.innerHTML = content
    } else {
      contents.append(...content.map(node => node.cloneNode(true)))
    }
    return container
  }

  function handleModal(modal, close, func) {
    modal.querySelector(".modal-title-row .modal-close").addEventListener("click", close)
    let down
    modal.addEventListener("mousedown", e => down = e.target)
    modal.addEventListener("mouseup", e => {
      if (down === e.target && e.target.classList.contains("modal-container")) {
        close()
      }
    })
    modal.addEventListener("keydown", e => {
      if (e.key === "Escape") {
        close()
      } else if (e.key === "Tab") {
        const focusable = modal.querySelectorAll(
          'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        )
        if (!focusable.length) return
        const first = focusable[0]
        const last = focusable[focusable.length - 1]
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault()
          last.focus()
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault()
          first.focus()
        }
      }
    })
    modals.append(modal)
    if (func) {
      const modalElement = modal.querySelector(".modal-element")
      modalElement.close = close
      func(modalElement)
    }
  }

  function openModal(title, content, id, func) {
    const modal = makeModal(title, content, id)
    function close() {
      modal.classList.remove("open")
      setTimeout(() => {
        modal.remove()
        const all = modals.querySelectorAll(".modal-container")
        if (all.length) {
          all[all.length - 1].focus()
        }
      }, 150)
    }
    handleModal(modal, close, func)
    setTimeout(() => {
      modal.classList.add("open")
      const focusable = modal.querySelectorAll(
        'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
      )
      if (focusable.length > 1) {
        focusable[1].focus()
      } else {
        modal.focus()
      }
    }, 0)
  }

  document.querySelectorAll(".modal").forEach(e => {
    e._modalData = {
      title: e.dataset.title,
      content: [...e.children],
      id: e.dataset.modalId ?? e.dataset.trigger + "-modal"
    }
  })

  document.addEventListener("click", e => {
    document.querySelectorAll(".modal").forEach(el => {
      if (e.target.closest(`.${el.dataset.trigger}`)) {
        openModal(el._modalData.title, el._modalData.content, el._modalData.id)
      }
    })
  })

  document.querySelectorAll("[data-modal]").forEach(el => {
    el.addEventListener("click", () => {
      openModal(
        el.dataset.modalTitle,
        el.dataset.modal,
        el.dataset.modalId
      )
    })
  })

  function showModal(title, content, func, id) {
    openModal(title, content, id, func)
  }

  // Newsletter

  if (location.search.includes("customer_posted=true") && location.hash === "#newsletter") {
    showModal("Signed up!", "Thanks for subscribing to our newsletter!")
    const url = new URL(location)
    url.searchParams.delete("customer_posted")
    history.replaceState(null, "", url.pathname + url.search)
  }

  // Product Cards

  const cards = document.querySelectorAll(".ante-product-card")

  function adjustCards() {
    for (const card of cards) {
      if (!card.top) {
        card.top = card.querySelector(".on-top")
      }
      card.top.style.bottom = card.offsetHeight - card.offsetWidth + "px"
    }
  }

  let lastWidth = window.innerWidth
  window.addEventListener("resize", () => {
    const newWidth = window.innerWidth
    if (newWidth === lastWidth) return
    lastWidth = newWidth
    adjustCards()
  })

  adjustCards()

  // Inits

  initMarquees()

  document.addEventListener("shopify:section:load", () => {
    initMarquees()
  })
})